import API from '../dataApi';

export const submitDemoRequest = (data) => API.post('/demo-requests', data);
export const getDemoRequests = (status) => API.get('/demo-requests', { params: { status } });
export const reviewDemoRequest = (id, data) => API.put(`/demo-requests/${id}/review`, data);
